/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import classNames from 'classnames';
import { IoIosArrowBack } from 'react-icons/io';
import nova from 'logo.svg';
import nova_small from 'logo_small.svg';

type SidebarHeaderNovaProps = {
    state: boolean;
    toggleState: () => void;
};
const SidebarHeaderNova = ({ state, toggleState }: SidebarHeaderNovaProps) => {
    return (
        <div className="sidebar__header">
            <div className={`logo logo-full ${state ? 'collapsed' : ''}`}>
                <img src={nova} alt="Nova Horizontal SVG" />
            </div>
            <div className={`logo logo-small ${state ? '' : 'collapsed'}`}>
                <img src={nova_small} alt="Nova Small SVG" />
            </div>

            <button
                className={classNames('toggle-btn', { collapsed: state })}
                onClick={toggleState}
            >
                <IoIosArrowBack />
            </button>
        </div>
    );
};

export default SidebarHeaderNova;
